import { Box, alpha } from '@mui/material';
import { styled } from '@mui/material/styles';

interface StyledBoxProps {
  maxTitleHeight?: number;
}
const StyledBox = styled(Box)<StyledBoxProps>(({ theme, maxTitleHeight }) => ({
  background: theme.palette.background.primary,
  borderTop: `1px solid ${theme.palette.border[3]}`,
  padding: theme.spacing(14, 0, 14, 0),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(8, 0),
  },
  '& .OTHSIcon': {
    width: theme.spacing(4.5),
    height: theme.spacing(4.5),
    marginBottom: theme.spacing(3),
  },
  '& .OTHSList': {
    paddingLeft: theme.spacing(1),
    margin: 0,
    listStyle: 'none',
  },

  '& .OTHSListItem': {
    display: 'flex',
    alignItems: 'flex-start',
    padding: 0,
    marginBottom: theme.spacing(0.5),
    position: 'relative',
    '&::before': {
      content: '""',
      width: theme.spacing(0.5),
      height: theme.spacing(0.5),
      backgroundColor: theme.palette.text.secondary,
      borderRadius: theme.typography.pxToRem(1),
      marginTop: theme.spacing(1),
      marginRight: theme.spacing(1.5),
      flexShrink: 0,
    },
  },
  '& .OTHighLightItem': {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  '& .OTHighLightItemTitle': {
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('lg')]: {
      minHeight: maxTitleHeight || theme.spacing(3.5),
    },
  },
}));

export default StyledBox;
